// src/components/Content.js
import React from 'react';
import './Content.css';

// Eski içerik bileşenleriniz (sidebar'dan gelenler)
import FormSection from './FormSection/FormSection';
import LeaveSection from './LeaveSection/LeaveSection';
import CumaMailing from './CumaMailing/CumaMailing';
import ShortUrlSection from './ShortUrlSection/ShortUrlSection';
import NotesAddSection from './NotesAddSection/NotesAddSection';
import TrendsSection from './TrendsSection/TrendsSection';
import BrandsSection from './BrandsSection/BrandsSection';
import BilgilerSection from './BilgilerSection/BilgilerSection';
import YoneticiSection from './YoneticiSection/YoneticiSection';
import RoleManagement from './YoneticiSection/RoleManagement';

// Yeni üst orta menü bileşenleri
import AnasayfaSection from './AnasayfaSection/AnasayfaSection';
import TakimSection from './TakimSection/TakimSection';
import InsanKaynaklariSection from './InsanKaynaklariSection/InsanKaynaklariSection';
import TakvimSection from './TakvimSection/TakvimSection';


import PuzzleMenu from "./PuzzleMenu/PuzzleMenu"; // 🟢 Puzzle Menü Dahil Edildi


import Logout from './Login/Logout';


// React Icons
import { 
  FaBell, 
  FaCog, 
  FaHome, 
  FaUsers, 
  FaUserTie, 
  FaCalendarAlt 
} from 'react-icons/fa';

const Content = ({ activeItem, onCenterItemClick }) => {
  // Üst orta menüde gösterilecek 4 öğe
  const centerMenuItems = [
    { id: 100, label: 'Anasayfa', icon: <FaHome /> },
    { id: 101, label: 'Takım', icon: <FaUsers /> },
    { id: 102, label: 'Talepler', icon: <FaUserTie /> },
    { id: 103, label: 'Takvim', icon: <FaCalendarAlt /> },
  ];

  // Sidebar menüsüne göre içerik
  // 0..8 -> Eski switch
  // 100..103 -> Yeni switch
  const renderContent = () => {
    switch (activeItem) {
      // --- SIDEBAR CASE'LER ---
      case 0:  return <FormSection />;
      case 1:  return <LeaveSection />;
      case 2:  return <ShortUrlSection />;
      case 3:  return <NotesAddSection />;
      case 4:  return <TrendsSection />;
      case 5:  return <BrandsSection />;
      case 6:  return <CumaMailing />;
      case 7:  return <BilgilerSection />;
      case 8:  return <YoneticiSection />;
      case 9:  return <RoleManagement />;
      
      // --- ÜST ORTA MENÜ CASE'LER ---
      case 100: return <AnasayfaSection />;
      case 101: return <TakimSection />;
      case 102: return <InsanKaynaklariSection />;
      case 103: return <TakvimSection />;

      default:
        return <div>Lütfen bir menü seçin.</div>;
    }
  };
  const storedUser = sessionStorage.getItem('user');
  const userObj = storedUser ? JSON.parse(storedUser) : {};
  // adından ilk harfi çıkar, yoksa U
  const userInitial = (userObj.name?.charAt(0).toUpperCase()) || 'U';
  return (
    <div className="content">
      {/* Üst Header */}
      <div className="header-info">
        {/* Sol kısım: Profil */}
        <div className="profile-section">
        <div className="profile-initial">{userInitial}</div>
              <div>
                <strong>{userObj.name} {userObj.surname}</strong><br/>
              <span> {userObj.email}</span><br/>
              <span> {userObj.position}</span> <br/>
              </div>
        </div>
{/* Orta: Puzzle Menü */}
<PuzzleMenu activeItem={activeItem} onCenterItemClick={onCenterItemClick} />
        {/* Orta kısım: 4 ikonlu menü */}
        {/* Sağ kısım: Bildirim & Ayarlar */}
        <div className="right-icons">
                      <Logout />
                      
        </div>
      </div>

      {/* İçerik Body */}
      <div className="content-body">
        {renderContent()}
      </div>
    </div>
  );
};

export default Content;
